/**
 * Max length for chart display name sent as multipart `displayName` / `display_name`.
 * Kept generous so list labels match the editor; trim only to protect oversized payloads.
 */
export const CHART_DISPLAY_NAME_MAX_CHARS = 2048;
